import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import configurator from './modules/configurator/index';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import initialState from './state';

Vue.use(Vuex);

export default new Vuex.Store({
  state: () => initialState(),
  actions,
  mutations,
  getters,
  modules: {
    configurator,
  },
  plugins: [
    createPersistedState({
      reducer: state => {
        return {
          configurations: state.configurations,
          configurationType: state.configurationType,
          configurator: {
            type: state.configurator.type,
            files: state.configurator.files.filter(file => file.uploaded),
          },
        };
      },
    }),
  ],
});
